import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ChevronDown, UtensilsCrossed } from 'lucide-react';
import { BakeryEvent } from '../types/event';
interface EventMenuProps {
  id: string;
  menu: NonNullable<BakeryEvent['menu']>;
}
const ease = [0.23, 1, 0.32, 1] as const;
export function EventMenu({
  id,
  menu
}: EventMenuProps) {
  const [open, setOpen] = useState(false);
  const reduceMotion = useReducedMotion();
  const panelId = `${id}-menu-panel`;
  return <section className="mt-5 rounded-xl border border-[#FF7A1A]/25 overflow-hidden" data-id="element-453" data-mp="22eo422b6py8a">
      <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-controls={panelId} className="w-full flex items-center justify-between gap-4 px-4 py-3.5 md:px-6 text-left hover:bg-[#FF7A1A]/5 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#FF7A1A]/60" data-id="element-454" data-mp="1omrcq0hcbscy">
        <span className="flex items-center gap-3 min-w-0" data-id="element-455" data-mp="2fye5pkw6mxq1">
          <UtensilsCrossed className="w-5 h-5 text-[#FF9A4D] shrink-0" aria-hidden="true" data-id="element-456" data-mp="2fwtb5v9vbes6" />
          <span className="min-w-0" data-id="element-457" data-mp="2b1xkozka4zh6">
            <span className="block font-bold text-[#F5EDE3]" data-id="element-458" data-mp="2ozm03rvkveeu">
              {open ? 'Dölj menyn' : 'Se menyn'}
            </span>
            <span className="block text-xs font-semibold text-[#FFB27A]" data-id="element-459" data-mp="2ky8zpxb983fb">
              À la carte · ingen buffé
            </span>
          </span>
        </span>
        <ChevronDown className={`w-5 h-5 text-[#FF9A4D] shrink-0 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-460" data-mp="1s9uxt6h1omyh" />
      </button>

      <AnimatePresence initial={false} data-id="element-461" data-mp="21987o092zdjq">
        {open && <motion.div id={panelId} key="menu" initial={reduceMotion ? false : {
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={reduceMotion ? {
        opacity: 0
      } : {
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease
      }} className="overflow-hidden" data-id="element-462" data-mp="217nh0lpw0er5">
            <div className="px-4 pb-5 md:px-6 border-t border-[#FF7A1A]/15" data-id="element-463" data-mp="3dkuax5xu6whp">
              <h4 className="pt-4 halloween-display text-2xl text-[#FF9A4D] tracking-wide" data-id="element-464" data-mp="3ie6kc8ty2wpv">
                {menu.title}
              </h4>
              <p className="mt-1.5 text-sm text-[#F5EDE3]/65 leading-relaxed" data-id="element-465" data-mp="3neb1m12ofvh5">
                {menu.intro}
              </p>
              <ul className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-x-8" data-id="element-466" data-mp="2unaxlq4cirph">
                {menu.items.map(item => <li key={item.name} className="py-3 border-t border-dashed border-[#F5EDE3]/12" data-id="element-467" data-mp="2zme1v8ci4twe">
                    <p className="font-bold text-[#F5EDE3]" data-id="element-468" data-mp="34jdzqvz76qcf">{item.name}</p>
                    {item.description && <p className="mt-0.5 text-sm text-[#F5EDE3]/60 leading-relaxed" data-id="element-469" data-mp="jv9fu9oq0pi4">
                        {item.description}
                      </p>}
                  </li>)}
              </ul>
            </div>
          </motion.div>}
      </AnimatePresence>
    </section>;
}